/* Rashid is a WhatsApp handoff, not an on-site messaging/calling service. */
(function () {
  'use strict';
  var wrap = document.getElementById('wa-widget');
  var panel = document.getElementById('wa-panel');
  var btn = document.getElementById('wa-btn');
  if (!wrap || !panel || !btn || wrap.dataset.waWidgetInited === 'true') return;
  var backdrop = document.getElementById('wa-backdrop');
  var draft = document.getElementById('wa-chat-draft');
  var send = document.getElementById('wa-chat-send');
  var form = document.getElementById('wa-chat-form');
  var strings = JSON.parse(document.getElementById('wa-widget-strings').textContent);
  var views = Array.from(panel.querySelectorAll('[data-wa-view]'));
  var stack = [];
  var statusTimer, viewportFrame, restoreTimer;
  var inertSiblings = new Map();
  var focusable = 'a[href], button:not([disabled]), textarea:not([disabled]), [tabindex="0"]';
  // Initialization runs on first hover. Re-appending the already-mounted
  // launcher restarts its invitation animation and briefly clears :hover.
  // Only portal nodes that actually need to escape a containing element.
  [wrap, backdrop, panel].forEach(function (element) {
    if (element.parentElement !== document.body) document.body.appendChild(element);
  });
  document.body.classList.toggle('wa-pos-bl', wrap.dataset.position === 'bl');
  wrap.dataset.waWidgetInited = 'true';
  panel.inert = true;

  function opened() { return panel.classList.contains('is-open'); }
  function topView() { return stack.length ? stack[stack.length - 1].view : panel; }
  function focusFirst(root) {
    var first = Array.from(root.querySelectorAll(focusable)).find(function (el) {
      return !el.closest('[inert], [hidden]') && el.getClientRects().length;
    });
    (first || root).focus({ preventScroll: true });
  }
  function syncViews() {
    var active = topView();
    Array.from(panel.children).forEach(function (el) {
      if (el.matches('[data-wa-view]')) return;
      el.inert = stack.length > 0;
    });
    views.forEach(function (view) {
      var isTop = view === active;
      view.classList.toggle('is-open', isTop);
      view.inert = !isTop;
      view.setAttribute('aria-hidden', String(!isTop));
    });
    panel.querySelectorAll('[data-wa-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', String(active.id === el.dataset.waOpen));
    });
  }
  function openView(id, trigger) {
    var view = document.getElementById(id);
    if (!view || !views.includes(view)) return;
    stack.push({view: view, trigger: trigger});
    if (id === 'wa-chat-gift') document.getElementById('wa-copy-status').textContent = '';
    syncViews();
    focusFirst(view);
  }
  function closeView() {
    var previous = stack.pop();
    syncViews();
    if (previous && previous.trigger && !previous.trigger.closest('[inert]')) previous.trigger.focus({preventScroll:true});
    else focusFirst(topView());
  }
  function lockBackground() {
    Array.from(document.body.children).forEach(function (el) {
      if (el === panel || el === backdrop || /^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) return;
      inertSiblings.set(el, el.inert);
      el.inert = true;
    });
  }
  function unlockBackground() {
    inertSiblings.forEach(function (wasInert, el) { el.inert = wasInert; });
    inertSiblings.clear();
  }
  function updateStatus() {
    var text = strings.status_neutral;
    if (wrap.dataset.hoursEnabled === 'true') {
      try {
        var parts = new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Dubai', weekday:'short',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
        var day = parts.find(function(p){return p.type === 'weekday';}).value;
        var hour = Number(parts.find(function(p){return p.type === 'hour';}).value);
        var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var enabledDays = wrap.dataset.hoursDays.split(',').map(function(d){return d.trim();});
        var isOpen = enabledDays.includes(String(days.indexOf(day))) && hour >= Number(wrap.dataset.hoursOpen) && hour < Number(wrap.dataset.hoursClose);
        text = isOpen ? strings.status_open : strings.status_closed;
      } catch (e) { /* Unknown time is never advertised as live agent presence. */ }
    }
    panel.querySelector('[data-wa-status]').textContent = text;
  }
  function keyboardInset() {
    viewportFrame = null;
    var vv = window.visualViewport;
    panel.style.height = panel.style.maxHeight = panel.style.bottom = '';
    if (!opened() || !vv || !matchMedia('(max-width: 767.98px)').matches) return;
    var inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    if (inset > 80) {
      panel.style.height = panel.style.maxHeight = vv.height + 'px';
      panel.style.bottom = inset + 'px';
    }
  }
  function scheduleViewport() {
    if (viewportFrame == null) viewportFrame = requestAnimationFrame(keyboardInset);
  }
  function openPanel() {
    clearTimeout(restoreTimer);
    stack = []; syncViews(); panel.inert = false;
    panel.classList.add('is-open'); panel.setAttribute('aria-hidden','false');
    btn.setAttribute('aria-expanded','true'); backdrop.classList.add('is-open');
    lockBackground(); updateStatus();
    clearInterval(statusTimer); statusTimer = setInterval(updateStatus, 60000);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleViewport);
      window.visualViewport.addEventListener('scroll', scheduleViewport);
    }
    keyboardInset();
    // Do not force the mobile keyboard open before the shopper chooses to type.
    document.getElementById('wa-close').focus({preventScroll:true});
  }
  function closePanel(restoreFocus) {
    if (!opened()) return;
    stack = []; syncViews();
    clearInterval(statusTimer);
    panel.classList.remove('is-open'); panel.setAttribute('aria-hidden','true'); panel.inert = true;
    btn.setAttribute('aria-expanded','false'); backdrop.classList.remove('is-open');
    unlockBackground();
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', scheduleViewport);
      window.visualViewport.removeEventListener('scroll', scheduleViewport);
    }
    if (viewportFrame != null) cancelAnimationFrame(viewportFrame);
    viewportFrame = null; keyboardInset();
    if (restoreFocus !== false) {
      btn.focus({preventScroll:true});
      restoreTimer = setTimeout(function(){if (!opened()) btn.focus({preventScroll:true});},300);
    }
  }
  window.closeWhatsAppPanel = closePanel;
  btn.addEventListener('click', function(e){e.preventDefault();opened() ? closePanel() : openPanel();});
  btn.addEventListener('keydown', function(e){if(e.key===' '){e.preventDefault();btn.click();}});
  document.getElementById('wa-close').addEventListener('click', function(){closePanel();});
  backdrop.addEventListener('click', function(){closePanel();});
  window.addEventListener('pageshow', function(e){if(e.persisted) closePanel(false);});
  document.addEventListener('visibilitychange', function(){if(opened() && !document.hidden) updateStatus();});
  document.addEventListener('keydown', function(e){
    if (!opened()) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); stack.length ? closeView() : closePanel(); }
    if (e.key !== 'Tab') return;
    var list = Array.from(topView().querySelectorAll(focusable)).filter(function(el){return !el.closest('[inert], [hidden]') && el.getClientRects().length;});
    if (!list.length) {e.preventDefault();return;}
    var index = list.indexOf(document.activeElement);
    e.preventDefault();
    var next = index < 0 ? (e.shiftKey ? list.length - 1 : 0) : (index + (e.shiftKey ? -1 : 1) + list.length) % list.length;
    list[next].focus({preventScroll:true});
  }, true);
  panel.addEventListener('click', function(e){
    var opener = e.target.closest('[data-wa-open]');
    var closer = e.target.closest('[data-wa-view-close]');
    if (opener) openView(opener.dataset.waOpen, opener);
    if (closer) closeView();
    var emoji = e.target.closest('[data-wa-emoji]');
    if (emoji) {
      draft.value += emoji.dataset.waEmoji;
      closeView(); draft.focus(); syncDraft();
    }
  });
  function syncDraft() {
    form.classList.toggle('has-text', !!draft.value.trim());
    draft.style.height = 'auto'; draft.style.height = Math.min(draft.scrollHeight, 120) + 'px';
  }
  function sendMessage() {
    var text = draft.value.trim();
    if (wrap.dataset.productTitle && wrap.dataset.productUrl) {
      var url = new URL(wrap.dataset.productUrl);
      var variant = document.querySelector('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]');
      if (variant && /^\d+$/.test(variant.value)) url.searchParams.set('variant',variant.value);
      text += (text ? '\n\n' : '') + strings.product + ': ' + wrap.dataset.productTitle + '\n' + url.href;
    }
    var a = document.createElement('a');
    a.href = 'https://wa.me/' + wrap.dataset.phone + (text ? '?text=' + encodeURIComponent(text) : '');
    a.target = '_blank'; a.rel = 'noopener noreferrer';
    document.body.appendChild(a); a.click(); a.remove();
    closePanel(); // Keep draft intact: opening WhatsApp does not prove delivery.
  }
  draft.addEventListener('input',syncDraft);
  form.addEventListener('submit',function(e){e.preventDefault();sendMessage();});
  draft.addEventListener('keydown',function(e){if(e.key==='Enter'&&!e.shiftKey&&!e.isComposing){e.preventDefault();sendMessage();}});
  syncDraft();
  var copy = document.getElementById('wa-chat-gift-copy');
  if (copy) copy.addEventListener('click',async function(){
    var code = copy.dataset.waGiftCode;
    var copied = false;
    try {await navigator.clipboard.writeText(code);copied=true;} catch(e) {
      var area=document.createElement('textarea'); area.value=code; area.style.position='absolute';area.style.opacity='0';
      topView().appendChild(area);area.select();
      try {copied=document.execCommand('copy')===true;} catch(ignore) {}
      area.remove();copy.focus({preventScroll:true});
    }
    document.getElementById('wa-copy-status').textContent=copied ? strings.copied : strings.copy_failed;
  });
})();
